export const locale = {
    lang: 'vn',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'DASHBOARD'        : {
                'TITLE': 'Trang chủ'
            },
            'ANNOUNCEMENT_CENTER': 'Kênh thông tin Artstuff',
            'APPROVALS': 'Đơn từ',
            'MYREQUEST': {
                'TITLE': 'Đơn từ của tôi',
                'BADGE': '0'
            },
            'APPROVALREQUEST': {
                'TITLE': 'Phê duyệt đơn từ',
                'BADGE': '10'
            },
            'MANAGEMENT': {
              'GROUP_NAME': 'Quản lý',
            },
            'MANAGEDORDER': {
                'TITLE': 'Quản lý đơn từ',
                'BADGE': '0'
            },
            'ANNOUNCEMENT_MANAGEMENT': {
                'TITLE': 'Quản lý kênh thông tin',
                'BADGE': '0'
            },
            'EMPLOYEE_INFORMATION': {
                'TITLE': 'Thông tin nhân viên',
                'BADGE' : '0',
            },
            'SETTING': {
                'GROUP_NAME': 'Cài Đặt',
                'WORKING_CALENDAR': 'Lịch làm việc',
                'WORKING_TIME': {
                  'TITLE': 'Thời gian làm việc',
                  'BADGE' : '0',
                } ,
                'HOLIDAY': {
                  'TITLE': 'Thời gian nghỉ lễ',
                  'BADGE' : '0',
                } ,
                'APPLICATION_FORM': 'Đơn từ',
                'APPLICATION_RULE': {
                  'TITLE': 'Quy định đơn từ',
                  'BADGE' : '0',
                },
                'CUT_OFF_TIME': {
                  'TITLE': 'Cut-off time đơn từ',
                  'BADGE' : '0',
                },
                'EMAIL_REMINDER': {
                  'TITLE': 'Email hệ thống',
                  'BADGE' : '0',
                },
                'EMPLOYEE_INFO': 'Thông tin nhân viên',
                'ANNUAL_LEAVE': {
                  'TITLE': 'Danh sách ngày phép',
                  'BADGE' : '0',
                }
            },
            'ADMINISTRATOR': {
              'GROUP_NAME': 'Quản Trị Hệ Thống',
              'EMPLOYEE_DATA': {
                'TITLE': 'Dữ liệu nhân viên',
                'BADGE' : '0',
              },
              'AVAILABLE_LEAVE_DATA': {
                'TITLE': 'Ngày phép khả dụng',
                'BADGE' : '0',
              },
            }
        }
    }
};
